/**
 * Plan names as the dashboard writes them, and the least plan that holds a
 * capability, from core's own table, so a plan change cannot leave a badge
 * behind.
 */
import {
  lowestPlanWith,
  type Capability,
  type Plan,
} from "@headerhawk/core/plans";

export const PLAN_NAMES: Record<Plan, string> = {
  free: "Free",
  team: "Team",
  professional: "Professional",
  business: "Business",
  enterprise: "Enterprise",
};

/** "Professional": the least plan holding `capability`. */
export function lowestPlanName(capability: Capability): string {
  return PLAN_NAMES[lowestPlanWith(capability)];
}

/** "On the Professional plan and above." */
export function describePlansWith(capability: Capability): string {
  return `On the ${lowestPlanName(capability)} plan and above.`;
}
